// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getLimbah, insertLimbah, limbahSelector, updateLimbah,} from "./limbahSlice";

import {Colors} from "../../../assets/Colors";

const LimbahPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const limbah = useSelector(limbahSelector);

    useEffect(() => {
        dispatch(
            getLimbah({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && limbah.isGetSuccess && !limbah.isGetFetching) {
            let calc = limbah?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = limbah.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && limbah.isGetSuccess && !limbah.isGetFetching) {
            let calc = limbah?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = limbah.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !limbah?.isGetFetching &&
            limbah.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = limbah?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = limbah.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getLimbah({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (limbah.isGetSuccess) {
                alertService.success(limbah.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getLimbah({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (limbah.isUpdateSuccess) {
                alertService.success(limbah.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateLimbah({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetLimbah(params) {
    //   return dispatch(getLimbah(params));
    // }

    function handleInsertLimbah(param) {
        setInsertFetch(true);
        const params = {
            NamaLimbah: param.inputTwoValue,
            KodeLimbah: param.inputOneValue,
        };

        dispatch(insertLimbah(params));
    }

    function handleUpdateLimbah(param) {
        setUpdateFetch(true);

        const params = {
            NamaLimbah: param.inputTwoValue,
            LimbahID: currentData.LimbahID,
            KodeLimbah: param.inputOneValue,
            status: param.status,
        };
        dispatch(updateLimbah(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getLimbah(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getLimbah(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = limbah.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? limbah.count : newCount,
            search: search,
        };
        dispatch(getLimbah(params));

        setPage(1);
        setCount(newCount === "-1" ? limbah.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Haz"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Haz"
                                tableData={limbah.data}
                                colOneTitle="ID"
                                colOneData="LimbahID"
                                colTwoTitle="Waste Code"
                                colTwoData="KodeLimbah"
                                colThreeTitle="Nama Haz"
                                colThreeData="NamaLimbah"
                                status="Status"
                                fetching={limbah.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Haz"
                        inputOneTitle="Waste Code"
                        inputOneValue=""
                        inputTwoTitle="Nama Haz"
                        inputTwoValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertLimbah}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.LimbahID}
                        modal={handleModal}
                        modalTitle="Ubah Limbah"
                        inputTwoTitle="Nama Limbah"
                        inputTwoValue={currentData.NamaLimbah}
                        inputOneTitle="Waste Code"
                        inputOneValue={currentData.KodeLimbah}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateLimbah}
                    />
                )}
            </div>
        );
    }
};

export default LimbahPage;
